// extracted by mini-css-extract-plugin
export default {"container":"ModularConfiguratorLayout__container___OvUA5"};